(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-common-wager/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-common-wager/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.mybets_common_wager = svs.numbergames.mybets_common_wager || {};
svs.numbergames.mybets_common_wager.models = svs.numbergames.mybets_common_wager.models || {};
svs.numbergames.mybets_common_wager.collections = svs.numbergames.mybets_common_wager.collections || {};
svs.numbergames.mybets_common_wager.logger = new svs.core.log.Logger('numbergames:mybets_common_wager');

 })(window);